import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SharedModule } from '../../../../shared.module';


@Component({
  selector: 'app-extend-session-dialog',
  templateUrl: './extend-session-dialog.component.html',
  styleUrls: ['./extend-session-dialog.component.scss'],
  standalone: true,
  imports: [SharedModule]
})
export class ExtendSessionDialogComponent implements OnInit, OnDestroy {

  countdown: number;
  private intervalId: any;

  constructor(
    private readonly dialogRef: MatDialogRef<ExtendSessionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { countdown: number }
  ) {
    this.countdown = data.countdown || 30; // fallback a 30 si no llega dato
  }

  ngOnInit() {
    this.intervalId = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        this.dialogRef.close();
      }
    }, 1000);
  }

  ngOnDestroy() {
    clearInterval(this.intervalId);
  }

  extend() {
    this.dialogRef.close('extend');
  }

  close() {
    this.dialogRef.close();
  }
}
